import firebase from 'firebase'

import { logToAnalytics } from './analytics'
import { ApplicationType } from 'app/types'

const appRef = (id: string) => {
    return firebase.firestore().doc(`applications/${id}`)
}

export const createApplication = (app: ApplicationType) => {
    return appRef(app.id).set(app).catch(console.error)
}

export const editApplication = (app: ApplicationType) => {
    return appRef(app.id).update(app).catch(console.error)
}

const usersPerOrgAppsRef = (orgId: string) =>
    firebase.firestore().collection(`usersPerOrg/${orgId}/applications`)

const appToAnalyticsProps = (application: any) => ({
    'app-name': application.applicationName,
    'app-id': application.applicationId,
    'app-domains': application.domains || []
})

export const addApplication = (orgId: string, appId: string) => {
    return usersPerOrgAppsRef(orgId)
        .doc(appId)
        .set({ id: appId })
        .then(() => logToAnalytics('add_application(app_library)'))
}

export const deleteApplication = async (orgId: string, app: ApplicationType) => {
    const application = await usersPerOrgAppsRef(orgId)
        .doc(app?.id)
        .get()
        .then(s => s?.data() || null)

    if (application?.autoAdded) {
        logToAnalytics('te_delete_application(app_library)', appToAnalyticsProps(app))
    }

    return usersPerOrgAppsRef(orgId)
        .doc(app.id)
        .delete()
        .then(() => logToAnalytics('delete_application', appToAnalyticsProps(app)))
}
